import { faMinusCircle } from "@fortawesome/pro-regular-svg-icons/faMinusCircle";
import { Typography } from "@mui/material";
import MuiMessageBox from "components/MuiExtras/MessageBox/MuiMessageBox";
import MuiContainer from "components/MuiExtras/MuiContainer";
import { FeedItemPublicationDto } from "models/ApiModels";
import * as React from "react";
import { useTranslation } from "react-i18next";

interface IProps {
    publication: FeedItemPublicationDto;
}

export const PublicationNoAccessInfo: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    return (
        <MuiMessageBox
            icon={faMinusCircle}
            variant={"error"}
            message={
                <div>
                    <MuiContainer>
                        <Typography variant="h5">
                            {props.publication.title}
                        </Typography>
                    </MuiContainer>
                    <Typography variant="body2">
                        <span>{t("Views.Publication.Components.PublicationNoAccessInfo.Message")}</span>
                    </Typography>
                </div>
            }
        />
    );
};
